if (!customElements.get('free-shipping-bar')) {
  customElements.define(
    'free-shipping-bar',
    class FreeShippingBar extends HTMLElement {
      connectedCallback() {
        this.threshold = Number(this.dataset.threshold);
        this.messageElement = this.querySelector('[data-free-shipping-message]');
        this.fillElement = this.querySelector('[data-free-shipping-fill]');
        this.checkElement = this.querySelector('[data-free-shipping-check]');

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      refresh() {
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        fetch(`${cartUrl}.js`)
          .then((response) => response.json())
          .then((cart) => this.render(cart.total_price))
          .catch((error) => console.error(error));
      }

      render(total) {
        if (!this.threshold || !this.messageElement || !this.fillElement) return;

        const remaining = Math.max(0, this.threshold - total);
        const unlocked = total > 0 && remaining === 0;
        const percent = Math.min(100, Math.round((total / this.threshold) * 100));

        this.fillElement.style.width = `${percent}%`;
        this.classList.toggle('free-shipping-bar--unlocked', unlocked);
        if (this.checkElement) this.checkElement.toggleAttribute('hidden', !unlocked);

        let message;
        if (total === 0) {
          message = (this.dataset.textEmpty || '').replace('[amount]', this.formatMoney(this.threshold));
        } else if (unlocked) {
          message = this.dataset.textUnlocked || '';
        } else {
          message = (this.dataset.textProgress || '').replace('[amount]', this.formatMoney(remaining));
        }
        this.messageElement.textContent = message;
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '${{amount}}';
        const value = cents / 100;

        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, placeholder) => {
          switch (placeholder) {
            case 'amount_no_decimals':
            case 'amount_no_decimals_with_comma_separator':
              return Math.round(value).toString();
            case 'amount_with_comma_separator':
              return value.toFixed(2).replace('.', ',');
            default:
              return value.toFixed(2);
          }
        });
      }
    }
  );
}
